import {
  assign, endpoint, options, check, convert,
} from '../helpers';

/**
 * The report returns the output of the excel column
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const excel = (properties) => {
  const props = assign(properties);
  const model = {
    Report: props.data.report,
    Query: props.data.query,
  };

  fetch(endpoint('/report-grid'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        props.success(response.Data);
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default excel;
